import { render, staticRenderFns } from "./Magazine.vue?vue&type=template&id=867c0d64&scoped=true&"
import script from "./Magazine.vue?vue&type=script&lang=js&"
export * from "./Magazine.vue?vue&type=script&lang=js&"
import style0 from "./Magazine.vue?vue&type=style&index=0&id=867c0d64&scoped=true&lang=css&"
import style1 from "./Magazine.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867c0d64",
  null
  
)

export default component.exports